import { action } from 'satcheljs';
/**
 * Action to propagate the delete items action to client stores
 * @param itemContexts - the contexts for items being deleted
 * @param parentFolderId - the parent FolderId
 */
export default action('DELETE_ITEMS_STORE_UPDATE', function (itemContexts, parentFolderId) {
    return {
        itemContexts: itemContexts,
        parentFolderId: parentFolderId,
    };
});
//# sourceMappingURL=deleteItemsStoreUpdate.js.map